// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1YYHt","range":"MonthRangeSwitch_range__1QMIb","disabled":"MonthRangeSwitch_disabled__FL0FQ"};